import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'app/auth/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService,
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean> | boolean {
        let status = this.authService.isLoggedIn();
        if (!status) {
            // Redirect to login with returnUrl
            this.router.navigate(['/login'], {
                queryParams: { returnUrl: state.url },
                replaceUrl: true, // optional: avoids user navigating "back" to a protected route
            });
        }
        return status;
    }
}
